import React, { useCallback, useEffect, useState } from "react"

import { ReactComponent as CheckIcon } from "@common_assets/svg/check.svg"
import { ReactComponent as CrossIcon } from "@common_assets/svg/cross.svg"
import { ReactComponent as EyeClosedIcon } from "@common_assets/svg/eye-closed.svg"
import { ReactComponent as EyeOpenIcon } from "@common_assets/svg/eye-open.svg"
import { InputAdornment, useTheme } from "@mui/material"
import TextField from "components/form/common/field/textField"
import { useWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { passwordSchema } from "utils/yup"

interface IProps {
  isSignUp?: boolean
}

const PasswordTextField = ({ isSignUp }: IProps) => {
  const theme = useTheme()
  const [showPass, setShowPass] = useState(false)
  const { t } = useTranslation()

  const password = useWatch({ name: "password" })

  const [isPasswordValid, setIsPasswordValid] = useState(false)

  useEffect(() => {
    if (password && password.length > 0) {
      passwordSchema
        .isValid(password)
        .then((isValid) => {
          setIsPasswordValid(isValid)
        })
        .catch(() => {
          setIsPasswordValid(false)
        })
    } else {
      setIsPasswordValid(false)
    }
  }, [password])

  const showSign = useCallback(() => {
    if (!password || password.length === 0) {
      return null
    }

    if (isPasswordValid) {
      return (
        <CheckIcon
          style={{
            color: theme.palette.mockup.success50,
          }}
        />
      )
    }

    if (!isPasswordValid) {
      return (
        <CrossIcon
          style={{
            color: theme.palette.mockup.error50,
          }}
        />
      )
    }

    return null
  }, [isPasswordValid, password, theme.palette.mockup.error50, theme.palette.mockup.success50])

  return (
    <TextField
      name="password"
      type={showPass ? "text" : "password"}
      fullWidth
      label={t("noAuthFlow.password")}
      slotProps={{
        input: {
          endAdornment: (
            <>
              {isSignUp && showSign()}
              <InputAdornment
                component="button"
                type="button"
                aria-label={
                  showPass
                    ? t("noAuthFlow.hidePassword")
                    : t("noAuthFlow.showPassword")
                }
                sx={[
                  {
                    cursor: "pointer",
                    color: "primary.main",
                    border: "none",
                    background: "none",
                    padding: 0,
                    margin: 0,
                    fontFamily: "inherit",
                  },

                  (theme) => ({
                    "&:hover": {
                      color: theme.palette.mockup.primary80,
                    },
                  }),
                ]}
                position={"start"}
                onClick={() => setShowPass(!showPass)}
              >
                {showPass ? <EyeOpenIcon /> : <EyeClosedIcon />}
              </InputAdornment>
            </>
          ),
        },
      }}
    />
  )
}

export default PasswordTextField
